import {
  ALERT_TEST_ACTION,
} from './constants';

export function alertTestAction() {
  return {
    type: ALERT_TEST_ACTION,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case ALERT_TEST_ACTION:
      return {
        ...state,
      };

    default:
      return state;
  }
}
